<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <choice_general_tab :location="location"></choice_general_tab>
        </template>

        <template v-slot:location_categories="{ location, name }">
            <location_super_categs :location="location"></location_super_categs>
        </template>


    </base_location_modal>
</template>

<script>
import base_location_modal from "../../base/location_modal/base_location_modal";
import Choice_general_tab from "./tabs/choice_general_tab";
import Location_super_categs from "../../base/location_modal/tabs/location_super_categs";

export default {
    name: "choice_location_modal",
    components : {
        Choice_general_tab,
        base_location_modal,
        Location_super_categs
    },
    data () {
        return {
            tabs_add: []
        }
    }
}
</script>

<style scoped>

</style>
